module.exports = __webpack_public_path__ + "static/media/cricketweb.8866b285.jpeg";